// "Your rooms" on the landing page: rooms this browser has been in, newest first. Kept in localStorage
// like the player's name; removing one only takes it off this list.
export interface RecentRoom {
  slug: string;
  gameId: string;
  players: string[];   // the other people's names, as last seen
  at: number;          // last visit, ms
}

const KEY = 'recent-rooms';
const MAX = 8;

export function loadRecentRooms(): RecentRoom[] {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    return Array.isArray(list) ? list.filter(r => r && typeof r.slug === 'string') : [];
  } catch { return []; }
}

function save(list: RecentRoom[]) {
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch { /* storage full or blocked */ }
}

export function rememberRoom(entry: RecentRoom) {
  save([entry, ...loadRecentRooms().filter(r => r.slug !== entry.slug)]);
}

export function forgetRoom(slug: string): RecentRoom[] {
  const list = loadRecentRooms().filter(r => r.slug !== slug);
  save(list);
  return list;
}

export function timeAgo(at: number, now = Date.now()): string {
  const m = Math.round((now - at) / 60000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} hour${h > 1 ? 's' : ''} ago`;
  const d = Math.round(h / 24);
  return d === 1 ? 'yesterday' : `${d} days ago`;
}
